import { useState } from 'react'
import { Button } from '#app/components/ui/button'
import { Icon } from '#app/components/ui/icon'

interface ActivosData {
	inmuebles: string
	rodados: string
	valoresMobiliarios: string
	otrosActivos: string
}

interface ManifestacionBienesActivosScreenProps {
	onNext: (data: ActivosData) => void
	onBack: () => void
	data?: Partial<ActivosData>
}

export function ManifestacionBienesActivosScreen({
	onNext,
	onBack,
	data,
}: ManifestacionBienesActivosScreenProps) {
	const [formData, setFormData] = useState<ActivosData>({
		inmuebles: data?.inmuebles || '',
		rodados: data?.rodados || '',
		valoresMobiliarios: data?.valoresMobiliarios || '',
		otrosActivos: data?.otrosActivos || '',
	})

	const handleSubmit = () => {
		onNext(formData)
	}

	return (
		<div className="flex h-full w-full flex-col">
			<div className="flex-1 overflow-y-auto">
				<div className="flex w-full flex-col items-center gap-6">
					<h2 className="font-parkinsans text-center text-2xl leading-8 font-medium text-blue-800">
						Activos
					</h2>
					<p className="text-center text-sm text-neutral-600">
						Detalla los bienes que conforman tu patrimonio. Todos los campos son
						opcionales.
					</p>

					<div className="flex w-full flex-col gap-4">
						<div className="flex flex-col gap-2">
							<label className="text-sm font-medium text-neutral-700">
								Inmuebles
							</label>
							<p className="text-xs text-neutral-500">
								Indicar dominio, ubicación, destino, año de adquisición e
								importe. Si está gravado o inscripto como Bien de Familia,
								indicarlo.
							</p>
							<textarea
								className="w-full rounded-xl border border-neutral-300 px-4 py-3 text-base"
								rows={4}
								placeholder="Ej: Depto en Av. Corrientes 1234, CABA. Dominio: Tomo X, Folio Y. Destino: Vivienda. Año: 2015. Importe: $50.000.000"
								value={formData.inmuebles}
								onChange={(e) =>
									setFormData({ ...formData, inmuebles: e.target.value })
								}
							/>
						</div>

						<div className="flex flex-col gap-2">
							<label className="text-sm font-medium text-neutral-700">
								Rodados
							</label>
							<p className="text-xs text-neutral-500">
								Descripción, marca, modelo, patente e importe.
							</p>
							<textarea
								className="w-full rounded-xl border border-neutral-300 px-4 py-3 text-base"
								rows={3}
								placeholder="Ej: Automóvil Toyota Corolla 2020, Patente AB123CD. Importe: $15.000.000"
								value={formData.rodados}
								onChange={(e) =>
									setFormData({ ...formData, rodados: e.target.value })
								}
							/>
						</div>

						<div className="flex flex-col gap-2">
							<label className="text-sm font-medium text-neutral-700">
								Valores Mobiliarios y Participación en Sociedades
							</label>
							<p className="text-xs text-neutral-500">
								Acciones, bonos, participaciones societarias e importes.
							</p>
							<textarea
								className="w-full rounded-xl border border-neutral-300 px-4 py-3 text-base"
								rows={3}
								placeholder="Ej: 10% participación en Empresa SA. Importe: $5.000.000"
								value={formData.valoresMobiliarios}
								onChange={(e) =>
									setFormData({
										...formData,
										valoresMobiliarios: e.target.value,
									})
								}
							/>
						</div>

						<div className="flex flex-col gap-2">
							<label className="text-sm font-medium text-neutral-700">
								Otros Activos
							</label>
							<p className="text-xs text-neutral-500">
								Cualquier otro bien de valor (maquinaria, equipos, etc.)
							</p>
							<textarea
								className="w-full rounded-xl border border-neutral-300 px-4 py-3 text-base"
								rows={3}
								placeholder="Ej: Maquinaria industrial. Importe: $2.000.000"
								value={formData.otrosActivos}
								onChange={(e) =>
									setFormData({ ...formData, otrosActivos: e.target.value })
								}
							/>
						</div>
					</div>
				</div>
			</div>

			<div className="flex w-full shrink-0 flex-col items-center justify-start gap-2 bg-white pt-4 md:flex-row md:justify-between md:bg-transparent md:pt-8">
				<Button
					variant="primary"
					appearance="ghost"
					size="l"
					onClick={onBack}
					className="order-2 w-full gap-2 rounded-xl px-4 py-3 text-sm leading-4 md:order-1 md:w-auto md:px-6 md:py-4 md:text-base md:leading-5"
				>
					<Icon name="arrow-left" className="size-4" />
					Atrás
				</Button>
				<Button
					variant="secondary"
					appearance="solid"
					size="l"
					onClick={handleSubmit}
					className="order-1 w-full md:order-2 md:w-auto"
				>
					Siguiente
					<Icon name="arrow-right" className="size-3.5" />
				</Button>
			</div>
		</div>
	)
}
